"use client";
import { createContext, useContext, useState } from "react";

const InfoContext = createContext<any>(null);

interface VideoInfo {
  content: string;
  video: string;
  videoHigh: string;
  music: string;
  cover: string;
  images: string;
  extractType: string;
  name: string;
  sourceUrl?: string;
}

export function InfoProvider({ children }: { children: React.ReactNode }) {
  const [info, setInfo] = useState<VideoInfo>();
  return (
    <InfoContext.Provider value={{ info, setInfo }}>
      {children}
    </InfoContext.Provider>
  );
}

export function useInfo() {
  return useContext(InfoContext);
}
